import { render } from "./CreditNoteTotalDetails.vue?vue&type=template&id=4dc33904"
import script from "./CreditNoteTotalDetails.vue?vue&type=script&lang=js"
export * from "./CreditNoteTotalDetails.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__